import React, { createContext, useState, useContext, useEffect } from 'react';

const PatientContext = createContext();

export const PatientProvider = ({ children }) => {
  const [selectedPatientId, setSelectedPatientId] = useState(() => {
    // Initialize from localStorage
    return localStorage.getItem('selectedPatientId') || null;
  });

  useEffect(() => {
    // Persist to localStorage whenever it changes
    if (selectedPatientId) {
      localStorage.setItem('selectedPatientId', selectedPatientId);
    } else {
      localStorage.removeItem('selectedPatientId');
    }
  }, [selectedPatientId]);

  return (
    <PatientContext.Provider value={{ selectedPatientId, setSelectedPatientId }}>
      {children}
    </PatientContext.Provider>
  );
};

export const usePatientContext = () => {
  const context = useContext(PatientContext);
  if (!context) {
    throw new Error('usePatientContext must be used within a PatientProvider');
  }
  return context;
};
